export enum SvgIconGraphicsType {
	circle,
	ellipse,
	line,
	path,
	polygon,
	polyline,
	rect,
	g
}

export interface ISvgIconGraphics {
	type: SvgIconGraphicsType;
	attributes: any;
	subNodes: ISvgIconGraphics[];
}
